export const config: any = {

  defaultLocale: "us",

  API_URL: "assets/api",
  LARAVEL_URL: "api/",

};
